(function (app, ng) {

    app.directive("editDisplay", ["$animate", "$q", "$timeout", function ($animate, $q, $timeout) {
        return {
            //scope: {Model:"=model"}, 
            scope: true,
            require: ["editDisplay"],
            controller: [function () {
                var self = this;
                this.edit = [];
                this.display = [];
                this.autofocus = null;
                this.editMode = false;
                this.$edit = function () {
                    self.editMode = true;
                };
                this.$display = function () {
                    $timeout(function () { self.editMode = false });
                };
            }],
            controllerAs: "Display",
            link: function (scope, elem, attr, ctrls) {
                var ctrl = ctrls[0];
                var scopes = [];
                var elements = [];
                scope.$watch("Display.editMode", function (value) {
                    //remove old elements and destroy old scopes
                    ng.forEach(elements, function (el) {
                        $animate.leave(el);
                    });
                    ng.forEach(scopes, function (s) {
                        s.$destroy();
                    });
                    scopes = [];
                    elements = [];

                    //create new elements and scopes
                    var transcludes = value ? ctrl.edit : ctrl.display;
                    var promises = [];
                    ng.forEach(transcludes, function (t) {
                        var d = $q.defer();
                        promises.push(d.promise);
                        t.transclude(function (childElement, childScope) {
                            scopes.push(childScope);
                            elements.push(childElement);
                            $animate.enter(childElement, elem, null, function () {
                                d.resolve();
                            });
                        });
                    });
                    //once all animations are done - autofocus the element if one has been set
                    if (value && ctrl.autofocus) {
                        ctrl.autofocus.focus();
                    }
                });
            }
        };
    }]);

    app.directive("editMode", [function () {
        return {
            transclude: "element",
            priority: 1200,
            require: ["^editDisplay"],
            link: function (scope, elem, attrs, ctrls, transclude) {
                var editMode = ctrls[0];
                editMode["edit"].push({ transclude: transclude, element: elem });
            }
        };
    }]);

    app.directive("editModeAutofocus", [function () {
        return {
            require: ["^editDisplay"],
            link: function (scope, elem, attrs, ctrls) {
                var ctrl = ctrls[0];
                ctrl.autofocus = elem;
            }
        };
    }]);

    app.directive("displayMode", [function () {
        return {
            //scope: {Model:"=model"}, 
            transclude: "element",
            priority: 1200,
            require: ["^editDisplay"],
            link: function (scope, elem, attrs, ctrls, transclude) {
                var editMode = ctrls[0];
                editMode["display"].push({ transclude: transclude, element: elem });
            }
        };
    }]);

})(window.app, window.angular); //jshint ignore:line